// extracted by mini-css-extract-plugin
module.exports = {"container":"UpdateAvailable_container_11bhX","show":"UpdateAvailable_show_oUUZP"};